import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '320px',
    marginTop: 100,
    marginBottom: 80,
    backgroundColor: theme.palette.background.default,
  },

  contentBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    marginBottom: '100px',

    [theme.breakpoints.down('xs')]: {
      marginBottom: '40px',
    },
  },

  badge: {
    display: 'inline-flex',
    border: '1px solid #06E89F',
    borderRadius: '20px',
    padding: '6px 18px',
    marginBottom: '40px',
    boxShadow: '0px 0px 8px 0px rgba(6, 232, 159, 0.35)',
  },

  badgeText: {
    fontFamily: 'MontserratSemiBold',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: '#06E89F',
  },

  title: {
    margin: 0,
    marginBottom: '32px',

    fontFamily: 'MontserratBold',
    fontSize: '48px',
    lineHeight: 1.15,
    letterSpacing: '-1px',
    maxWidth: '820px',

    color: theme.palette.hero.title,

    [theme.breakpoints.down('md')]: {
      fontSize: '36px',
      maxWidth: '100%',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '26px',
      letterSpacing: '-0.5px',
    },
  },

  subtitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    width: '100%',
    marginBottom: '36px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
    },
  },

  subtitle: {
    fontFamily: 'MontserratRegular',
    fontSize: '18px',
    lineHeight: 1.5,
    flex: 1,
    maxWidth: '620px',
    margin: '0 auto',
    order: 0,

    color: theme.palette.hero.subtitle,

    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      marginBottom: '10px',
    },

    [theme.breakpoints.down('sm')]: {
      order: 1,
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      maxWidth: '100%',
    },
  },

  buttonsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    flexWrap: 'wrap',
    width: '100%',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
    },
  },

  stateCard: {
    flexShrink: 0,
    order: 0,
    border: `1px solid ${theme.palette.hero.cardBorder}`,
    borderRadius: '12px',
    padding: '16px 20px',
    minWidth: '220px',
    textAlign: 'left',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',

    [theme.breakpoints.down('sm')]: {
      order: 2,
      width: '100%',
      minWidth: 'unset',
      textAlign: 'center',
    },
  },

  stateLabel: {
    display: 'block',
    marginBottom: '4px',

    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: theme.palette.hero.cardText,
  },

  stateLabelTarget: {
    display: 'block',
    marginBottom: '4px',

    fontFamily: 'MontserratSemiBold',
    fontSize: '10px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: theme.palette.hero.cardLabelTarget,
  },

  stateTitle: {
    margin: 0,
    fontFamily: 'MontserratBold',
    fontSize: '16px',
    color: theme.palette.hero.cardTitle,
  },

  stateText: {
    margin: 0,
    fontFamily: 'MontserratRegular',
    fontSize: '13px',
    color: theme.palette.hero.cardText,
  },

  ambitionSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
  },

  ambitionLabel: {
    display: 'block',
    marginBottom: '16px',

    fontFamily: 'MontserratSemiBold',
    fontSize: '13px',
    letterSpacing: '2px',
    textTransform: 'uppercase',

    color: theme.palette.hero.ambitionLabel,
  },

  ambitionQuote: {
    fontFamily: 'MontserratRegular',
    fontSize: '22px',
    lineHeight: 1.5,
    maxWidth: '900px',
    margin: 0,

    color: theme.palette.hero.ambitionQuote,

    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
    },
  },
}));

export default useStyles;
